var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{staticStyle:{"object-fit":"scale-down"},attrs:{"src":"/images/common/loading_great_pro.gif","width":"120","height":"120"}})}
var staticRenderFns = []

export { render, staticRenderFns }